// Inspired by https://github.com/shadcn-ui/ui/pull/4532/files
<script setup lang="ts">
import type { RadioGroupItemProps } from 'reka-ui';
import { RadioGroupItem, useForwardProps } from 'reka-ui';
import type { HTMLAttributes } from 'vue';
import { computed } from 'vue';

import { cn } from '@/lib/utils';

const props = defineProps<RadioGroupItemProps & { class?: HTMLAttributes['class'] }>();

const delegatedProps = computed(() => {
  const { class: _, ...delegated } = props;
  return delegated;
});

const forwardedProps = useForwardProps(delegatedProps);
</script>

<template>
  <RadioGroupItem
    v-bind="forwardedProps"
    :class="
      cn(
        'rounded-lg border bg-white text-primary-600 shadow-sm transition data-[state=checked]:border-primary-500 data-[state=checked]:bg-beige-300 data-[state=checked]:text-primary-700',
        props.class,
      )
    "
  >
    <slot />
  </RadioGroupItem>
</template>
